import { COMPANY_FILTER_CHANGE } from '../../../PartnerOptions/constants'

import {
  LICENSE_DATA_REQUEST_ASYNC,
  RESET_SELECTED_ADDONS,
  TOGGLE_ADDON_TO_UNLOCK,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    license: {},
    selectedAddonsToUnlock: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case LICENSE_DATA_REQUEST_ASYNC.INITIATE:
      case COMPANY_FILTER_CHANGE:
        return { ...state, loader: true }
      case LICENSE_DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          license: { ...action.payload.data },
          loader: false,
        }
      case LICENSE_DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case LICENSE_DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case TOGGLE_ADDON_TO_UNLOCK: {
        const selectedAddonsToUnlock = state.selectedAddonsToUnlock.includes(action.payload.addon)
          ? state.selectedAddonsToUnlock.filter((addon) => addon !== action.payload.addon)
          : [...state.selectedAddonsToUnlock, action.payload.addon]
        return { ...state, selectedAddonsToUnlock }
      }
      case RESET_SELECTED_ADDONS:
        return { ...state, selectedAddonsToUnlock: [] }
      default:
        return state
    }
  }
}
